export default "__VITE_ASSET__C8oGPgSZ__"